export default __webpack_public_path__ + "static/media/pregnant.a242e1e6.svg";